import WatchPartyContent from './WatchPartyContent'

export default WatchPartyContent;
